import { motion } from "framer-motion";
import { springPresets } from "@/lib/motion";

const QUOTES = [
  {
    text: "Küçük hanımlar, küçük beyler! Sizler geleceğin aydınlığı, umudusunuz!",
    attribute: "Mustafa Kemal Atatürk",
  },
  {
    text: "Bugünün küçükleri, yarının büyükleridir.",
    attribute: "Mustafa Kemal Atatürk",
  },
  {
    text: "Egemenlik kayıtsız şartsız milletindir.",
    attribute: "Mustafa Kemal Atatürk",
  },
];

export function AtaturkQuotes() {
  return (
    <section
      id="tarihce"
      className="py-16 px-4 relative overflow-hidden"
      style={{
        background: "linear-gradient(135deg, oklch(0.48 0.24 12) 0%, oklch(0.35 0.20 12) 50%, oklch(0.22 0.12 240) 100%)",
      }}
    >
      {/* Decorative circles */}
      <div className="absolute top-0 right-0 w-64 h-64 rounded-full opacity-10"
        style={{ background: "radial-gradient(circle, white 0%, transparent 70%)", transform: "translate(30%, -30%)" }} />
      <div className="absolute bottom-0 left-0 w-48 h-48 rounded-full opacity-10"
        style={{ background: "radial-gradient(circle, white 0%, transparent 70%)", transform: "translate(-30%, 30%)" }} />

      <div className="max-w-5xl mx-auto relative z-10">
        <div className="text-center mb-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={springPresets.gentle}
          >
            <div className="text-5xl mb-4">🇹🇷</div>
            <h2 className="text-3xl font-black text-white mb-3" style={{ fontFamily: "'Merriweather', serif" }}>
              Atatürk'ün Sözleri
            </h2>
            <p className="text-white/70 max-w-lg mx-auto text-sm">
              Mustafa Kemal Atatürk, çocuklara ve gençlere büyük önem verdi.
              İşte onun kılavuz sözleri:
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {QUOTES.map((quote, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ ...springPresets.gentle, delay: i * 0.1 }}
              whileHover={{ scale: 1.02, y: -4 }}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 text-center"
            >
              <div className="text-4xl text-yellow-300 mb-3" style={{ fontFamily: "'Noto Serif', serif" }}>"</div>
              <p className="text-white font-medium text-base leading-relaxed mb-4 italic"
                style={{ fontFamily: "'Noto Serif', serif" }}>
                {quote.text}
              </p>
              <div className="w-12 h-0.5 bg-yellow-300/60 mx-auto mb-3" />
              <span className="text-yellow-200 text-sm font-semibold">— {quote.attribute}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
